module.exports = __webpack_public_path__ + "img/add-file.2d781b5d.svg";